  (function () {
    var KLAVIYO_PUBLIC_API_KEY = 'Rg5wMZ';
    var KLAVIYO_REVISION = '2026-04-15';

    function cleanValue(value) {
      return String(value || '').trim();
    }

    function getUrlParameter(name) {
      try {
        return new URLSearchParams(window.location.search).get(name) || '';
      } catch (error) {
        return '';
      }
    }

    function getSignupMonth() {
      var date = new Date();

      return (
        date.getFullYear() +
        '-' +
        String(date.getMonth() + 1).padStart(2, '0')
      );
    }

    function createUniqueId(formId) {
      if (
        window.crypto &&
        typeof window.crypto.randomUUID === 'function'
      ) {
        return window.crypto.randomUUID();
      }

      return (
        formId +
        '-' +
        Date.now() +
        '-' +
        Math.random().toString(36).slice(2)
      );
    }

    function buildTrackingData(configuration) {
      return {
        form_id: cleanValue(configuration.formId),
        form_name: cleanValue(configuration.formName),
        lead_magnet: cleanValue(configuration.leadMagnet),
        signup_category: cleanValue(configuration.signupCategory),
        klaviyo_list_id: cleanValue(configuration.listId),

        page_path: window.location.pathname,
        page_title: document.title,
        page_location: window.location.href,
        referring_page: document.referrer || 'Direct',

        signup_month: getSignupMonth(),

        utm_source: getUrlParameter('utm_source'),
        utm_medium: getUrlParameter('utm_medium'),
        utm_campaign: getUrlParameter('utm_campaign'),
        utm_content: getUrlParameter('utm_content')
      };
    }

    function sendToGA4(trackingData) {
      if (typeof window.gtag !== 'function') {
        console.warn(
          'GA4 gtag was not found. GA4 signup event was not sent.'
        );

        return;
      }

      /*
       * Never send the subscriber's email address to GA4.
       */
      window.gtag('event', 'klaviyo_api_form_submit', {
        form_id: trackingData.form_id,
        form_name: trackingData.form_name,
        lead_magnet: trackingData.lead_magnet,
        signup_category: trackingData.signup_category,
        klaviyo_list_id: trackingData.klaviyo_list_id,

        page_path: trackingData.page_path,
        page_title: trackingData.page_title,
        page_location: trackingData.page_location,
        referring_page: trackingData.referring_page,

        signup_month: trackingData.signup_month,

        utm_source: trackingData.utm_source,
        utm_medium: trackingData.utm_medium,
        utm_campaign: trackingData.utm_campaign,
        utm_content: trackingData.utm_content,

        transport_type: 'beacon'
      });
    }

    async function sendToKlaviyo(configuration, trackingData) {
      var email = cleanValue(configuration.email).toLowerCase();

      if (!email) {
        throw new Error(
          'An email address is required to create the Klaviyo event.'
        );
      }

      var endpoint =
        'https://a.klaviyo.com/client/events' +
        '?company_id=' +
        encodeURIComponent(KLAVIYO_PUBLIC_API_KEY);

      var payload = {
        data: {
          type: 'event',

          attributes: {
            unique_id: createUniqueId(trackingData.form_id),

            properties: {
              'Form ID': trackingData.form_id,
              'Form Name': trackingData.form_name,
              'Lead Magnet': trackingData.lead_magnet,
              'Signup Category': trackingData.signup_category,
              'Klaviyo List ID': trackingData.klaviyo_list_id,

              'Page Path': trackingData.page_path,
              'Page Title': trackingData.page_title,
              'Page URL': trackingData.page_location,
              'Referring Page': trackingData.referring_page,

              'Signup Month': trackingData.signup_month,

              'UTM Source': trackingData.utm_source,
              'UTM Medium': trackingData.utm_medium,
              'UTM Campaign': trackingData.utm_campaign,
              'UTM Content': trackingData.utm_content
            },

            metric: {
              data: {
                type: 'metric',

                attributes: {
                  name: 'BE Form Submitted'
                }
              }
            },

            profile: {
              data: {
                type: 'profile',

                attributes: {
                  email: email,
                  first_name:
                    cleanValue(configuration.firstName) || null,
                  last_name:
                    cleanValue(configuration.lastName) || null
                }
              }
            }
          }
        }
      };

      var response = await fetch(endpoint, {
        method: 'POST',

        headers: {
          accept: 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json',
          revision: KLAVIYO_REVISION
        },

        keepalive: true,
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        var errorMessage =
          'Klaviyo did not accept the form-submission event.';

        try {
          var responseData = await response.json();

          if (
            responseData &&
            responseData.errors &&
            responseData.errors.length &&
            responseData.errors[0].detail
          ) {
            errorMessage = responseData.errors[0].detail;
          }
        } catch (error) {
          /* Use the default error message. */
        }

        throw new Error(errorMessage);
      }
    }

    window.BETrackApiFormSubmission = async function (configuration) {
      var trackingData = buildTrackingData(configuration);

      /*
       * Send the non-personal reporting event to GA4.
       */
      sendToGA4(trackingData);

      /*
       * Send the profile-linked event to Klaviyo.
       */
      await sendToKlaviyo(configuration, trackingData);

      console.log(
        'Beauty Explained API form submission tracked:',
        trackingData
      );

      return trackingData;
    };
  })();
